import { FormattedMessage } from 'react-intl';

import type { VehicleConfig } from '../../types';

interface AssetInfoPanelProps {
    vehicle: VehicleConfig;
}

const AssetInfoPanel = ({ vehicle }: AssetInfoPanelProps) => (
    <div>
        <div className="row margin-bottom-10">
            <div className="col-xs-4">
                <div className="text-size-11 text-bold text-color-gray text-uppercase margin-bottom-2">
                    <FormattedMessage id="intl-msg:assetInfo.assetId" />
                </div>
                <div className="text-size-14 text-medium font-family-mono">{vehicle.asset_id}</div>
            </div>
            <div className="col-xs-3">
                <div className="text-size-11 text-bold text-color-gray text-uppercase margin-bottom-2">
                    <FormattedMessage id="intl-msg:assetInfo.assetName" />
                </div>
                <div className="text-size-14 text-medium">{vehicle.asset_name}</div>
            </div>
            <div className="col-xs-3">
                <div className="text-size-11 text-bold text-color-gray text-uppercase margin-bottom-2">
                    <FormattedMessage id="intl-msg:assetInfo.vin" />
                </div>
                <div className="text-size-14 text-medium font-family-mono">{vehicle.vin}</div>
            </div>
            <div className="col-xs-2">
                <div className="text-size-11 text-bold text-color-gray text-uppercase margin-bottom-2">
                    <FormattedMessage id="intl-msg:assetInfo.deviceSerial" />
                </div>
                <div className="text-size-14 text-medium">{vehicle.device_serial_number}</div>
            </div>
        </div>
        <div className="row margin-bottom-10">
            <div className="col-xs-3">
                <div className="text-size-11 text-bold text-color-gray text-uppercase margin-bottom-2">
                    <FormattedMessage id="intl-msg:assetInfo.deviceType" />
                </div>
                <div className="text-size-14 text-medium">{vehicle.device_type}</div>
            </div>
            <div className="col-xs-3">
                <div className="text-size-11 text-bold text-color-gray text-uppercase margin-bottom-2">
                    <FormattedMessage id="intl-msg:assetInfo.assetType" />
                </div>
                <div className="text-size-14 text-medium">{vehicle.asset_type}</div>
            </div>
            <div className="col-xs-3">
                <div className="text-size-11 text-bold text-color-gray text-uppercase margin-bottom-2">
                    <FormattedMessage id="intl-msg:assetInfo.booking" />
                </div>
                <div className="text-size-14 text-medium">{vehicle.service_care_booking}</div>
            </div>
            <div className="col-xs-3">
                <div className="text-size-11 text-bold text-color-gray text-uppercase margin-bottom-2">
                    <FormattedMessage id="intl-msg:assetInfo.fuelType" />
                </div>
                <div className="text-size-14 text-medium">{vehicle.fuel_type.toUpperCase()}</div>
            </div>
        </div>
        <div className="row">
            <div className="col-xs-12">
                <div className="text-size-11 text-bold text-color-gray text-uppercase margin-bottom-2">
                    <FormattedMessage id="intl-msg:assetInfo.description" />
                </div>
                <div className="text-size-14 text-medium white-space-pre-line">{vehicle.description}</div>
            </div>
        </div>
    </div>
);

export default AssetInfoPanel;
